<template>
    <v-container fluid>
        <div class="modal-padding pay-modal">
            <div v-if="success">
                <div class="pay-icon">
                    <img
                        src="../../../assets/img/payment-success.png"
                        class="pay-more"
                    />
                </div>
                <div class="modal-top-success">
                    Congratulations, Payment Successful
                </div>
                <div class="modal-top-success-text">
                    You have successfully paid  
                   <span class="span-bold"> &#x20B9 {{ data ? data.total_amount : "-" }} </span>
                </div>
                <div v-if="data && data.product_name" class="modal-top-success-text">
                    Transaction successful for
                    <span class="span-bold">{{ data.product_name }}</span>
                </div>
                <div v-else class="modal-top-success-text">
                    {{ noOfLicenses()
                        ? `Your subscription for ${noOfLicenses()} licenses is now renewed till`
                        : 'Your subscription is now renewed till'
                    }}
                   <span class="span-bold"> {{ expiryDate() }} </span>
                </div>
                <div class="modal-top-success-btm-block">
                    <div class="modal-top-success-btm">
                        Thank You
                    </div>
                </div>
            </div>
            <div v-if="failure">
                <div class="pay-icon">
                    <img
                        src="../../../assets/img/payment-failed.png"
                        class="pay-more"
                    />
                </div>
                <div class="modal-top-failure">
                    Sorry, Payment Unsuccessful
                </div>
                <div class="modal-top-success-text">
                    Something went wrong with the last transaction. Your account
                    has not been debited. However, if the amount has been
                    deducted then it will automatically be refunded back.
                </div>
                <div class="modal-top-failed-btm-block">
                    <v-btn
                        text
                        class="try-again"
                        color="primary"
                        @click="close()"
                        >Try again</v-btn
                    >
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
    name: "PaymentPopUp",
    props: ["onClose", "status", "data", "success", "failure"],
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        close() {
            this.onClose({
                status: false,
                success: this.success,
                failure: this.failure,
                data: this.data,
                retry: this.failure,
            });
        },
        purchasedModule() {
            if (this.data && this.data.module_ids && this.data.module_ids.length && this.data.selected_new_module && this.data.selected_new_module.length) {
                const modId = this.data.module_ids[0];
                return this.data.selected_new_module.find(m => m.module_id == modId);
            }

            return null;
        },
        expiryDate() {
            const dtformat = "DD - MMM - YYYY";
            const pm = this.purchasedModule();

            if (pm && pm.expiry_date) {
                return moment(pm.expiry_date).format(dtformat);
            }

            if (this.data && this.data.renewal && this.data.renewal.renewal_expiry_date ) {
				return moment(this.data.renewal.renewal_expiry_date).format(dtformat);
			}

            let myInstitute = JSON.parse(localStorage.getItem("myInstitute"));

            if (myInstitute && myInstitute.expiry_date) {
                return moment(myInstitute.expiry_date).format(dtformat);
            }
        },
        noOfLicenses() {
            const pm = this.purchasedModule();

            if (pm) {
                if (Number(pm.no_of_licences)) return this.data.required_licence;
                else return null;
            }

            return this.data.required_licence;
        },
    },
    computed: {
        ...mapState("userStore", ["user", "myInstitute"]),
    },
    watch: {
        status(val) {
            if (!val) {
                this.onClose({
                    status: val,
                    success: this.success,
                    failure: this.failure,
                    data: this.data,
                });
            }
        },
    },
    computed: {},
};
</script>
